<template>
  <div id="inside" style="">
    <nav class="navbar3 navbar-light navbar-expand" v-if="!loading">
      <div class="container justify-content-center pt-0">
        <button
          class="navbar-toggler navbar-toggler-right border-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbar3"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse text-center justify-content-center"
          id="navbar3"
        >
          <ul class="navbar-nav justify-content-between">
            <li
              v-bind:class="[
                this.currentPage !== 'meusAcordos'
                  ? 'nav-item border-bottom border-info mx-5 mb-2'
                  : 'nav-item mx-5',
              ]"
            >
              <a class="nav-link active" @click="home" style="cursor: pointer"
                >Propostas</a
              >
            </li>
            <li
              v-bind:class="[
                this.currentPage === 'meusAcordos'
                  ? 'nav-item border-bottom border-info mx-5 mb-2'
                  : 'nav-item mx-5',
              ]"
            >
              <a class="nav-link" @click="meusAcordos" style="cursor: pointer"
                >Acordos
                <span
                  class="badge badge-primary badge-pill"
                  v-if="agreements.length"
                  >{{ agreements !== null ? agreements.length : 0 }}</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div v-bind:class="largura > 500 ? 'container' : ''">
      <div class="row d-flex justify-content-center px16 my16">
        <div class="px-0 col-lg-12">
          <div class="stepper-wrapper">
            <div class="stepper-item completed">
              <div class="step-counter"></div>
            </div>
            <div class="stepper-item active">
              <div class="step-counter">2</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">3</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-12 mt-3">
        <div class="row">
          <div class="col-lg-12">
            <h6 class="mb-0" style="color: #3a4148; font-weight: 600">
              Tudo pronto? Revise as informações da negociação antes de
              finalizar o acordo.
            </h6>
          </div>
        </div>
      </div>
      <div class="d-inline-flex flex-wrap flex-column col-lg-12 mt-3">
        <div class="card" v-if="!loading">
          <div class="card-header">
            <h6 class="mb-0 p-3" style="color: #3a4148; font-weight: 600">
              Resumo da negociação
            </h6>
          </div>
          <div class="card-body">
            <div class="">
              <div class="d-flex" style="justify-content: space-between">
                <p>Contrato</p>
                <p>{{ contract.contrato }}</p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Valor atualizado</p>
                <p>R$ {{ installment.RETORNO.VALORPARCELAR }}</p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Valor desconto</p>
                <p style="font-weight: bold">
                  R$ {{ installment.RETORNO.DESCONTO }}
                </p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Percentual de desconto</p>
                <p>
                  {{
                    (
                      ((parseFloat(
                        installment.RETORNO.VALORPARCELAR.replace(
                          /\./g,
                          ""
                        ).replace(",", ".")
                      ) -
                        parseFloat(
                          installment.RETORNO.VALORTOTAL.replace(
                            /\./g,
                            ""
                          ).replace(",", ".")
                        )) /
                        parseFloat(
                          installment.RETORNO.VALORPARCELAR.replace(
                            /\./g,
                            ""
                          ).replace(",", ".")
                        )) *
                      100
                    ).toFixed(2)
                  }}%
                </p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Plano de pagamento</p>
                <p>
                  {{
                    installment.INSTALLMENTnUMBER === 0
                      ? "À vista"
                      : "Parcelado"
                  }}
                </p>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="Array.isArray(installment.PARCELAS)"
              >
                <p>Entrada</p>
                <p style="font-weight: bold">
                  R$ {{ installment.PARCELAS[0].PAGO }}
                </p>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="Array.isArray(installment.PARCELAS)"
              >
                <p>Parcelas</p>
                <p style="font-weight: bold">
                  + {{ installment.PARCELAS.length - 1 }}x R$
                  {{ installment.PARCELAS[0].PAGO }}
                </p>
              </div>
              <div class="d-flex" style="justify-content: space-between" v-else>
                <p>Parcelas</p>
                <p>1/1</p>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="!Array.isArray(installment.PARCELAS)"
              >
                <p>Valor à pagar</p>
                <p style="font-weight: bold">
                  R$ {{ installment.RETORNO.VALORTOTAL }}
                </p>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="Array.isArray(installment.PARCELAS)"
              >
                <p>Vencimento</p>
                <p>{{ installment.PARCELAS[0].VENCIMENTO }}</p>
              </div>
              <div class="d-flex" style="justify-content: space-between" v-else>
                <p>Vencimento</p>
                <p>{{ installment.PARCELAS.VENCIMENTO }}</p>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <p>Forma de pagamento</p>
                <p>Boleto</p>
              </div>
              <!-- <hr /> -->
              <!-- <p class="text-center">Texto de aceite.</p> -->
              <a
                class="btn mr-1 mt-3 mb-0 btn-outline-primary btn-block"
                href="#"
                v-if="loadingAgreement"
              >
                <ProgressLoading v-bind:loading="true"
              /></a>
            </div>
          </div>
        </div>

        <button
          class="btn btn-primary btn-block text-white mt-3"
          @click="openModalConfirmarAcordo()"
          style="cursor: pointer !important"
        >
          CONFIRMAR ACORDO
        </button>
        <a
          @click="voltar"
          class="text-center mt-4"
          style="text-decoration: underline; color: #03659b; cursor: pointer"
          >Voltar</a
        >

        <div class="card" v-if="loading">
          <ProgressLoading v-bind:loading="loading" />
        </div>
      </div>

      <div
        class="modal fade"
        id="confirmarAcordo"
        style="background-color: #000000a3"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirmar acordo</h5>
              <button type="button" @click="closeModalConfirmarAcordo()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <form class="mb-0">
                <div class="form-group my-0">
                  <div class="form-group mb-1">
                    <label>Você escolheu a opção:</label>
                    <div
                      class="contract-item"
                      v-if="!Array.isArray(installment.PARCELAS)"
                    >
                      <p class="text-center" style="font-weight: bold">
                        À vista: R$ {{ installment.RETORNO.VALORTOTAL }}
                      </p>
                    </div>
                    <div class="contract-item" v-else>
                      <p class="text-center" style="font-weight: bold">
                        Parcelado: Entrada de R$
                        {{ installment.PARCELAS[0].PRINCIPAL }} <br />
                        + {{ installment.PARCELAS.length - 1 }}x
                        {{ installment.PARCELAS[0].PRINCIPAL }}
                      </p>
                    </div>
                  </div>
                </div>
              </form>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loadingUpdateOffer ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button
                class="btn btn-primary btn-block mt-4"
                @click="setAgreement()"
                v-if="!loadingAgreement"
              >
                CONFIRMAR ACORDO
              </button>
              <button
                class="btn btn-link btn-block"
                :disabled="loading"
                @click="closeModalConfirmarAcordo()"
                v-if="!loadingAgreement"
              >
                CANCELAR
              </button>
              <ProgressLoading v-bind:loading="loadingAgreement" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
} from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import { sendAgreementCompletedBeacon } from "@/utils/abandonmentBeacon";

export default {
  name: "HistoricoPagamentos",
  components: {
    ProgressLoading,
  },
  data() {
    return {
      containParcel: false,
      loading: true,
      loadingAgreement: false,
      parcelado: false,
      currentPage: "resumoAcordo",
      openContractDetails: true,
      largura: null,
      agreements: null,
    };
  },
  async created() {
    this.ipUser = localStorage.getItem("ipUser") ?? "";
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
    this.largura = window.screen.width;
    this.contract = this.$route.params.contract;
    this.installment = this.$route.params.installment;

    const agreements = localStorage.getItem("agreements");
    this.agreements = agreements ? JSON.parse(agreements) : null;

    this.loading = false;
  },
  methods: {
    formatValue,
    formatData,
    formatDocument,

    ...mapActions("minhasDividas", [
      "ActionDividaNegociar",
      "ActionContractsAgreementResume",
      "ActionContractsAgreement",
      "ActionSetAgreement",
    ]),

    organizePayloadAgreement() {
      try {
        this.arrayToCall = [];

        var iso = (this.installment?.PARCELAS?.VENCIMENTO ?? "").replace(
          /(\d{1,2})\/(\d{1,2})\/(\d{4})/,
          (_, d, m, y) => `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`
        );

        if (!iso) {
          iso = (this.installment?.PARCELAS[0].VENCIMENTO ?? "").replace(
            /(\d{1,2})\/(\d{1,2})\/(\d{4})/,
            (_, d, m, y) => `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`
          );
        }

        var installmentNumber = this.installment.INSTALLMENTnUMBER;

        const thisContract = {
          document: this.contract.regis,
          credor: this.contract.credor,
          company: this.contract.company,
          inputValue: "0",
          installmentNumber: String(installmentNumber),
          installments: [],
          dueDate: iso,
          tag: localStorage.getItem("tag"),
        };

        (this.contract.parcelas || []).forEach((installment) => {
          thisContract.installments.push({
            contract: this.contract.contrato,
            product: this.contract.produto,
            dueInstallmentDate: installment.vencimento,
          });
        });

        this.arrayToCall.push(thisContract);

        const reqAgreement = {
          ...this.arrayToCall[0],
          installments: thisContract.installments,
          source: 1,
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser,
        };

        // (this.contract.parcelas || []).forEach((installment) => {
        //   reqAgreement.installments.push(installment);
        // });

        return reqAgreement;
      } catch (e) {
        this.loadDeal = !this.loadDeal;
        this.loadingAgreement = false;
        throw e;
      }
    },

    async setAgreement() {
      this.loadingAgreement = true;

      try {
        var payload = await this.organizePayloadAgreement();
        this.responseAgreement = await this.ActionSetAgreement(payload);

        if (this.responseAgreement) {
          this.flashMessage.show({
            timeout: 300,
            status: "success",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Sucesso",
            message: "Acordo realizado com sucesso!",
          });

          sendAgreementCompletedBeacon(
            this.user?.DebtorID,
            this.$store.state.auth.ownerId,
          );

          this.closeModalConfirmarAcordo();

          this.$router.push({
            name: "concluir",
            params: { responseAgreement: this.responseAgreement },
          });
        }

        this.loadDeal = !this.loadDeal;
        this.loadingAgreement = false;
      } catch (error) {
        this.loadingAgreement = false;
      }

      // this.$router.push({
      //   name: "concluir",
      //   // params: { agreement: this.contracts },
      // });
    },

    home() {
      localStorage.setItem("currentPage", "dashboard");
      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard" });
      }
    },

    meusAcordos() {
      localStorage.setItem("currentPage", "meusAcordos");
      this.$router.push({ name: "meusAcordos" });
    },

    openCloseContractsDetails() {
      this.openContractDetails = !this.openContractDetails;
    },

    voltar() {
      this.$router.push({
        name: "dashboard",
      });
    },

    openModalConfirmarAcordo() {
      // this.validateProposalOptions();
      const modal = document.getElementById("confirmarAcordo");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalConfirmarAcordo() {
      document.getElementById("confirmarAcordo").style.display = "none";
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("minhasDividas", [
      "agreementResume",
      "contractNegotiable",
      "contractNegotiableOptions",
    ]),
  },
};
</script>
<style scoped>
</style>
